import { getChannelInfo, getMenuList, getWatchLoginInfo, PostInfo, getPlayAddress, getDrainage } from '@/api/apiAll';
import QuickStorage from '@/utils/QuickStorage/index';

const actions = {
  async get_control({ state, commit, dispatch }, obj) {
    await Promise.all([dispatch('get_channerInfo', { id: obj.id, uin: obj.uin })]);
  },
  async get_channerInfo({ state, commit, dispatch }, obj) {
    const res = await getChannelInfo({
      id: obj.id,
      uin: obj.uin
    });
    if (res.code === 200 && res.errorCode === 0) {
      if (res.data.status !== 1 || Number(res.data.uin) !== Number(obj.uin)) {
        commit('set_status', 404);
        return false;
      }
      res.data.watchNum = 0;
      commit('set_channelInfo', res.data);
      commit('set_wechatInfo', res.data.channelWeChatInfo || {});
      commit('set_status', 200);
      await Promise.all([dispatch('get_menuList'), dispatch('get_drainage')]);
    } else if (res.code === 200 && res.errorCode === 3) {
      commit('set_status', 408);
    } else {
      commit('set_status', 404);
    }
  },
  async get_drainage({ state, commit }) {
    const { drainage_ID, drainage_status } = state.channelInfo
    if (!drainage_ID) return
    const drainage = await getDrainage({
      drainage_id: drainage_ID,
    })
    if (drainage.code === 200 && drainage.errorCode === 0) {
      commit('set_drainage', {
        ...drainage.data,
        drainage_ID,
        drainage_status,
      })
    }
  },
  async get_menuList({ state, commit }) {
    const res = await getMenuList({
      id: state.channelInfo.id,
      uin: state.channelInfo.uin
    });
    if (res.code === 200 && res.errorCode === 0) {
      let list = [];
      if (res.data.length) {
        list = res.data;
      } else {
        list = [
          {
            menuName: '聊天互动',
            menuType: 'chat'
          }
        ];
      }
      commit('set_menuList', list);
    }
  },
  async get_userInfo({ state, commit, dispatch }) {
    const res = await getWatchLoginInfo({
      id: state.channelInfo.id,
      uin: state.channelInfo.uin
    });
    if (res.code === 200 && res.errorCode === 0) {
      commit('set_userInfo', res.data.watchUserInfo);
      const channelInfo = JSON.parse(JSON.stringify(state.channelInfo));
      channelInfo.watchNum = res.data.watchNum;
      commit('set_channelInfo', channelInfo);
      dispatch('PostInfo');
    }
  },
  async PostInfo({ state }) {
    const res = await PostInfo({
      channelId: state.channelInfo.id,
      uin: state.channelInfo.uin,
      userId: state.userInfo.id || 0,
      type: 1, // tv
      deviceid: QuickStorage.localGet('DEVICE_ID')
    });
    if (res.code === 200 && res.errorCode === 0) {
      // console.log(res)
    }
  },
  async get_playAddress({ state, commit }) {
    const res = await getPlayAddress({
      id: state.channelInfo.id,
      uin: state.channelInfo.uin,
      clientId: state.uuid
    });
    if (res.code === 200 && res.errorCode === 0) {
      commit('set_playAddress', res.data.hlsUrl || '');
    }
  }
};
export default actions;
